const services = {
  oneYearListing: 'oneYearListing',
  mlsListing: 'mlsListing',
  extendListing: "extendListing", // 95
  extendListingNew: "extendListingNew", // 145
  withdrawListing: 'withdrawListing',
  updatePropertyInfo: 'updatePropertyInfo',
  updatePropertyInfo: 'updatePropertyInfo',
}

const prices = {
  [services.oneYearListing]: 95, // can't be dynamic
  [services.mlsListing]: 295,
  [services.extendListing]: 95,
    [services.extendListingNew]: 145,
  [services.withdrawListing]: 45,
  [services.updatePropertyInfo]: 20,
  [services.updatePropertyInfo]: 20,
}

export {
  services,
  prices,
}